<template>
  <div class="card">
    <div class="wrap">
      <div class="card-face-container">
        <img
          class="card-bg"
          src="../../../static/img/home/health_card_bg.png"
          alt=""
        />
        <div class="card-top-info">
          <div class="card-top-org">四川省卫生健康委员会</div>
          <div class="card-top-title">
            <img src="../../../static/img/icon-red-ten.png" alt="" />
            <span>电子健康卡</span>
          </div>
        </div>

        <div class="card-detail-info">
          <div class="card-user-info">
            <span class="card-user-name">{{ data.holderName }}</span>
            <span class="card-user-id">{{ data.cardNo | dotted }}</span>
          </div>
          <div class="card-qrcode">
            <img
              class="card-qrcode-logo"
              src="../../../static/img/card-logo.png"
              alt=""
            />
            <div ref="qrCodeUrl" id="qrCodeUrl"></div>
          </div>
        </div>

        <div class="card-footer">中华人民共和国国家卫生健康委员会监制</div>
      </div>
    </div>
  </div>
</template>

<script>
import QRCode from 'qrcodejs2'
export default {
  components: {
    QRCode
  },
  props: { data: Object },
  mounted () {
    new QRCode(this.$refs.qrCodeUrl, {
      text: this.data.qrCode,
      width: 86,
      height: 86,
      colorDark: "#000000",
      colorLight: "#ffffff",
      correctLevel: QRCode.CorrectLevel.H
    })
  },
}
</script>

<style lang="scss">
.card {
  position: relative;
  height: 4.8rem;
  font-size: 14px;

  .wrap {
    background: #f4f4f4;
    width: 100%;
  }

  .card-face-container {
    height: 4.8rem;
    margin: 0 auto;
    position: relative;
    color: #000000;
  }

  .card-face-container .card-bg {
    height: 100%;
    width: 100%;
    position: absolute;
  }

  .card-face-container .card-top-info {
    position: absolute;
    top: 0.31rem;
    width: calc(100% - 0.37rem - 0.46rem);
    padding: 0 0.37rem 0 0.46rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .card-face-container .card-top-info .card-top-org {
    font-size: 0.25rem;
    line-height: 0.34rem;
  }

  .card-face-container .card-top-info .card-top-title {
    display: flex;
    align-items: center;
    font-size: 0.4rem;
    line-height: 0.57rem;
    color: #2b2b2b;
  }

  .card-face-container .card-top-info .card-top-title span {
    font-size: 0.42rem;
  }

  .card-face-container .card-top-info .card-top-title img {
    height: 0.75rem;
    width: 0.75rem;
    margin-right: 0.1rem;
  }

  .card-face-container .card-detail-info {
    position: absolute;
    top: 1.6rem;
    width: calc(100% - 0.46rem - 0.2rem);
    padding: 0 0.2rem 0 0.46rem;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
  }

  .card-face-container .card-detail-info .card-user-info {
    font-size: 0.49rem;
    color: #2b2b2b;
  }

  .card-face-container .card-detail-info .card-user-info .card-user-name {
    height: 0.58rem;
    font-size: 0.63rem;
  }

  .card-face-container .card-detail-info .card-user-info .card-user-id {
    font-size: 0.4rem;
    line-height: 0.4rem;
    display: block;
    padding-top: 0.16rem;
  }

  .card-face-container .card-detail-info .card-qrcode {
    background: #ffffff;
    padding: 0.05rem;
    position: relative;
  }

  .card-face-container .card-detail-info .card-qrcode .card-qrcode-logo {
    height: 0.6rem;
    width: 0.6rem;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .card-face-container .card-detail-info .card-qrcode img {
    height: 2.1rem;
    width: 2.1rem;
  }

  .card-face-container .card-footer {
    position: absolute;
    font-size: 0.25rem;
    bottom: 0.22rem;
    left: 50%;
    transform: translateX(-50%);
    white-space: nowrap;
    letter-spacing: 0;
    line-height: 0.34rem;
  }
}
</style>



// WEBPACK FOOTER //
// health-card.vue?026f1adc